module.exports = __webpack_public_path__ + "static/media/bg.174a8e4a.jpg";